// extracted by mini-css-extract-plugin
module.exports = {"features":"Features-module--features--2AZYc","feature":"Features-module--feature--3Z1U3","feature__icon":"Features-module--feature__icon--3gySN"};